<template>
  <div class="wrap">
    <div v-if="popVisb">
      <div class="userHader">
        <div class="title">
          <span>您的问题或建议：</span>
        </div>
        <div>
          <textarea name
                    id
                    cols="30"
                    rows="5"
                    maxlength="200"
                    placeholder="请输入反馈内容"
                    v-model="fbContent"></textarea>
          <div class="num">
            <span>{{fbContent.length}}/200</span>
          </div>
        </div>
      </div>
      <div class="wrap-img">
        <div>
          <span class="title">相关截图</span>
        </div>
        <div class="upload">
          <div class="uploadBnt">
            <input type="file"
                   @change="getFile($event)" />
          </div>
          <div class
               v-for="(item,index) in addArr"
               :key="index">
            <i class="delIcon"
               @click="deleteImg(index)"></i>
            <img :src="item.url"
                 alt />
          </div>
        </div>
      </div>
      <div class="form">
        <span class="title">您的联系方式：</span>
        <div class="form-1rem">
          <input type="emial"
                 placeholder="请输入您的邮箱或手机号"
                 v-model="fbContact" />
        </div>
      </div>
      <div @click="save"
           class="save">
        <span>意见反馈</span>
      </div>
    </div>
    <div class="wrap-pop"
         v-else>
      <div class="popTitle">
        <span>
          <i class="duihao"></i>反馈成功
        </span>
        <span>感谢您的反馈，我们将尽快处理</span>
      </div>
      <div class="popMian">
        <span class="popMian-title">关注CMDHRA服务号 第一时间接受反馈回复</span>
        <div class="popMian-code">
          <img src="../../assets/images/erweima.png"
               alt />
        </div>
        <div class="line1rem"></div>
        <div class="popMain-bom">
          <span>长按二维码，识别并关注</span>
        </div>
      </div>
      <div class="pops-sure"
           @click="goBack">
        <span>返回个人中心</span>
      </div>
    </div>
  </div>
</template>
<script>
import grxx from "../../assets/images/grxx.png";
import woyy from "../../assets/images/woyy.png";
import wdsc from "../../assets/images/wdsc.png";
import next from "../../assets/images/next.png";
import loginService from "../../plugin/extendFn/loginService";
import AppSetting from '../../AppSetting';
export default {
  data () {
    return {
      popVisb: true,
      uName: null,
      wxuser: null,
      fbContent: "",
      fbContact: "",
      addArr: []
    };
  },
  props: {},
  computed: {},
  async  mounted () {
    this.$waiting.hide();
    var wxUser =await loginService.getLoginUser();
    if (wxUser) {
      this.uName = wxUser.uName;
      this.wxuser = wxUser;
    }
    this.sicon = this.wxuser
      ? this.wxuser.uIcon
        ? this.wxuser.uIcon
        : ""
      : "";
    // console.log(toString(this.wxuser.sIcon));
    // console.log(toString(null));

    document.title = "意见反馈";
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  methods: {
    deleteImg (index) {
      this.addArr.splice(index, 1);
    },
    uploadImage (file) {
      let formData = new FormData();
      formData.append("file", file);
      this.$postHttp(AppSetting.baseUrl + "/common/file/RAfeedback/" + this.wxuser.uId, formData).then(
        res => {
          if (res.data.code == 0) {
            this.addArr.push({
              url: res.data.urls[0].url,
              name: res.data.urls[0].file
            });
          }
        }
      );
    },
    getFile (event) {
      var file = event.target.files;
      for (var i = 0; i < file.length; i++) {
        //    上传类型判断
        var imgName = file[i].name;
        var idx = imgName.lastIndexOf(".");
        if (idx != -1) {
          var ext = imgName.substr(idx + 1).toUpperCase();
          ext = ext.toLowerCase();
          if (ext == "jpg" || ext == "png") {
            this.uploadImage(file[i]);
          }
        }
      }
    },
    goBack () {
      this.$router.go(-1);
    },
    save () {
      let param = {
        fbContent: this.fbContent,
        fbPicture: this.addArr.join(","),
        fbContact: this.fbContact,
        fbUId: this.wxuser.uId
      };
      this.$postHttp(AppSetting.baseUrl + "/feedback/app/add", param).then(res => {
        if (res.data.code == 0) {
          // this.wxuser = res.data.student;
          this.topTips("提交成功!");
          this.popVisb = false;
          // this.$router.go(-1);
        }
      });
    }
  },

  destroyed () {
    // alert(111)
  }
};
</script>
<style scoped lang="scss">
.wrap {
  min-height: 100vh;
  background: #f4f5f4;
  overflow: hidden;
  .title {
    font-size: 0.3rem;
    color: #333;
  }
  .userHader {
    font-size: 0.34rem;
    background: #fff;
    width: 100%;
    padding: 0.32rem;
    box-sizing: border-box;
    position: relative;
    textarea {
      width: 100%;
      background: rgba(255, 255, 255, 1);
      padding: 0.15rem 0.15rem;
      box-sizing: border-box;
      border: 1px solid rgba(210, 210, 210, 1);
      border-radius: 0.1rem;
      margin-top: 0.3rem;
      outline: none;
    }
    .num {
      font-size: 0.24rem;
      color: #666;
      border: 0.01rem solid #666;
      border-radius: 1rem;
      text-align: center;
      width: 1.3rem;
      position: absolute;
      right: 0.4rem;
      bottom: 0.6rem;
    }
  }
  .wrap-img {
    background: #fff;
    margin-top: 0.14rem;

    font-size: 12px;
    padding: 0.32rem;
    box-sizing: border-box;

    .upload {
      margin-top: 0.3rem;
      div {
        float: left;
        width: 1rem;
        height: 1rem;
        border: 0.01rem solid rgba(229, 229, 229, 1);
        margin-right: 0.15rem;
        background: url("../../assets/images/tianjia.png") no-repeat;
        background-size: 50% 50%;
        background-position: center;
        position: relative;
      }
      .uploadBnt {
        input {
          width: 100%;
          height: 100%;
          outline: none;
          opacity: 0;
        }
        overflow: hidden;
      }
      img {
        width: 100%;
        height: 100%;
      }
      .delIcon {
        display: inline-block;
        width: 0.21rem;
        height: 0.21rem;
        background: url("../../assets/images/guanbi.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        right: -0.1rem;
        top: -0.1rem;
      }
    }
  }
  .wrap-img::after {
    clear: both;
    display: block;
    content: "";
  }

  .form {
    font-size: 0.28rem;
    color: #333333;
    width: 100%;
    background: #fff;
    margin-top: 0.14rem;
    padding: 0.42rem 0.32rem;
    box-sizing: border-box;
    .form-1rem {
      width: 100%;
      input {
        width: 100%;
        outline: none;
        border: none;
        background: #fff;
        padding: 0.15rem 0.15rem;
        border: 1px solid rgba(210, 210, 210, 1);
        box-sizing: border-box;
        margin-top: 0.3rem;
      }
    }
  }
  .save {
    font-size: 0.34rem;
    color: #fff;
    background: #05a2ff;
    width: 80%;
    text-align: center;
    line-height: 1rem;

    margin: auto;
    margin-top: 0.7rem;
    border-radius: 0.1rem;
  }
  .wrap-pop {
    // position: absolute;
    // top: 0px;
    // left: 0px;
    // height: 100%;
    // width: 100%;
    // background: rgba(0,0,0,0.5);
    font-size: 0.32rem;
    color: #666666;
    box-sizing: border-box;
    height: 100%;

    .popTitle {
      text-align: center;
      font-size: 0.44rem;
      color: #4492ff;
      margin-top: 0.72rem;
      .duihao {
        display: inline-block;
        width: 0.58rem;
        height: 0.47rem;
        background: url("../../assets/images/duihao.png") no-repeat;
        background-size: 100% 100%;
        position: relative;
        top: 0.1rem;
        margin-right: 0.3rem;
      }
      span {
        display: block;
      }
      span:last-child {
        font-size: 0.28rem;
        color: #292929;
        margin-top: 0.42rem;
      }
    }
    .popMian {
      width: 80%;
      margin: auto;
      background: #fff;
      font-size: 0.28rem;
      color: #121922;
      padding-top: 0.47rem;
      margin-top: 0.64rem;
      padding-bottom: 0.47rem;
      box-sizing: border-box;
      .popMian-title {
        display: block;
        width: 2.85rem;
        text-align: center;
        margin: auto;
      }
      .popMian-code {
        width: 3.67rem;
        height: 3.67rem;
        background: black;
        margin: auto;
        margin-top: 0.31rem;
        img {
          width: 100%;
        }
      }
      .popMain-bom {
        text-align: center;
        margin-top: 0.33rem;
        font-size: 0.26rem;
        color: #7c838d;
      }
      .line1rem {
        width: 80%;
        height: 1px;
        background: #d9dce9;
        margin: auto;
        margin-top: 0.39rem;
      }
    }

    .pops-sure {
      font-size: 0.3rem;
      color: #fff;
      line-height: 0.8rem;
      width: 4.6rem;
      margin: auto;
      text-align: center;
      background: #05a2ff;
      border-radius: 0.1rem;
      margin-top: 0.91rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/me/feedback.vue